import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField,
} from "@mui/material";

export default function ReasonDialog({ open, setOpen, setReason ,onSubmit}) {
  
  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
       BackdropProps={{
    sx: {
      backdropFilter: 'blur(4px)', 
      backgroundColor: 'rgba(0, 0, 0, 0.2)', 
    },
  }}
    >
      <DialogContent sx={{ width: 500 }}>
        <TextField
          label="Enter Reason *"
          onChange={(e) => setReason(e.target.value)}
          multiline
          rows={5}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} color="primary" sx={{textTransform:"none"}}>
          Cancel
        </Button>
        <Button
          color="error"
          onClick={onSubmit}
          autoFocus
          variant="contained"
          className="gradientButton"
          sx={{textTransform:"none"}}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
